/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M6.445 12.668a.9.9 0 1 0-1.302 1.242l3.572 3.745a.9.9 0 0 0 1.335-.036l8.591-10.037a.9.9 0 0 0-1.367-1.17l-7.598 8.876a.48.48 0 0 1-.712.02l-2.519-2.64Z"
})), "0 0 24 24", "Check");